import { Card, Col, Row } from 'react-bootstrap';
import { Image } from "react-bootstrap";
import Learning from 'assets/img/th-each-ai/Learning.png';
import Skills from 'assets/img/th-each-ai/Skills.png';
import Community from 'assets/img/th-each-ai/Community.png';
import Feedback from 'assets/img/th-each-ai/Feedback.png';
import Meetings from 'assets/img/th-each-ai/Meetings.png';
import Analytics from 'assets/img/th-each-ai/Analytics.png';

import { useNavigate } from 'react-router-dom';
import NavbarBottom from 'components/modules/social/NavbarBottom';
import { useTranslation } from 'react-i18next';
//import TaskList from '../../../components/task-list/TaskList';
import MagazinePreview from './MagazinePreview';
import WorkLifeBalanceBox from './WorkLifeBalanceBox';
//import PromptWidget from 'components/prompts/PromptWidgets';
import PromptWidgetv2 from 'components/prompts/PromptWidgetsV2';


const UserDashboard: React.FC = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <>

            <div className='bg-white rounded-2'>
                <Row className='p-4 rounded-2'>
                    <Col lg={4} xl={4} className="d-none d-lg-block">
                        <Card className="min-vh-20 cursor-pointer" style={{ background: 'radial-gradient(circle, rgba(1,149,177,1) 0%, rgba(82,143,198,1) 100%)' }}
                            onClick={() => navigate("/learning")}>
                            <Card.Body className="d-flex flex-column justify-content-center"> {/* Added flex utilities */}
                                {/* First Row: Takes roughly half the space, content centered */}
                                <Row className="flex-grow-1 align-items-start justify-content-center" style={{ maxHeight: "60px" }}> {/* Added flex utilities */}
                                    <Col xs={8} sm={8}>
                                    </Col>
                                    <Col xs={4} sm={4} className="text-center text-sm-end"> {/* Center on small, align end on sm+ */}
                                        <img width={100}
                                            src={Learning}
                                            alt={t("Home.meetings")} />
                                    </Col>
                                </Row>

                                {/* Second Row: Takes the "rest" of the space, content centered */}
                                <Row className="flex-grow-1 align-items-center justify-content-center"> {/* Added flex utilities */}
                                    <Col className="text-center"> {/* Centered content */}
                                        <h2 className="text-white">Learning</h2>
                                    </Col>
                                </Row>

                                {/* Third Row: Takes roughly half the space, content centered */}
                                <Row className="g-3 flex-grow-1 align-items-end justify-content-center"> {/* Added flex utilities */}
                                    <Col className="text-left">
                                        <span className="hover-text-100 text-white fs-7 fw-semi-bold">
                                            {t("Home.grow")}
                                        </span>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col lg={4} xl={4}>
                        <Card className="min-vh-20 cursor-pointer" style={{ background: 'linear-gradient(121deg, rgba(238,201,86,1) 0%, rgba(234,180,57,1) 100%)' }}
                            onClick={() => navigate("/community")}>

                            <Card.Body className="d-flex flex-column justify-content-center"> {/* Added flex utilities */}
                                {/* First Row: Takes roughly half the space, content centered */}
                                <Row className="flex-grow-1 align-items-start justify-content-center" style={{ maxHeight: "60px" }}> {/* Added flex utilities */}
                                    <Col xs={8} sm={8}>
                                    </Col>
                                    <Col xs={4} sm={4} className="text-center text-sm-end"> {/* Center on small, align end on sm+ */}
                                        <img width={100}
                                            src={Community}
                                            alt="community"
                                            className=''
                                        />
                                    </Col>
                                </Row>

                                {/* Second Row: Takes the "rest" of the space, content centered */}
                                <Row className="flex-grow-1 align-items-center justify-content-center"> {/* Added flex utilities */}
                                    <Col className="text-center"> {/* Centered content */}
                                        <h2 className="text-white">{t("Home.community")}</h2>
                                    </Col>
                                </Row>

                                {/* Third Row: Takes roughly half the space, content centered */}
                                <Row className="g-3 flex-grow-1 align-items-end justify-content-center"> {/* Added flex utilities */}
                                    <Col className="text-left">

                                        <span className="hover-text-100 text-white fs-7 fw-semi-bold">
                                            {t("Home.connect")}
                                        </span>

                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col lg={4} xl={4}>
                        <Card className="min-vh-20 cursor-pointer" style={{ background: 'linear-gradient(121deg, rgba(195,109,216,1) 0%, rgba(112,86,210,1) 100%)' }}
                            onClick={() => navigate("/effective-communication")}>
                            <Card.Body className="d-flex flex-column justify-content-center"> {/* Added flex utilities */}
                                {/* First Row: Takes roughly half the space, content centered */}
                                <Row className="flex-grow-1 align-items-start justify-content-center" style={{ maxHeight: "60px" }}> {/* Added flex utilities */}
                                    <Col xs={8} sm={8}>
                                    </Col>
                                    <Col xs={4} sm={4} className="text-center text-sm-end"> {/* Center on small, align end on sm+ */}
                                        <img width={100}
                                            src={Meetings}
                                            alt="meetings"
                                        />
                                    </Col>
                                </Row>

                                {/* Second Row: Takes the "rest" of the space, content centered */}
                                <Row className="flex-grow-1 align-items-center justify-content-center" style={{ maxHeight: "60px" }}> {/* Added flex utilities */}
                                    <Col className="text-center"> {/* Centered content */}
                                        <h2 className="text-white">{t("Meetings")}</h2>
                                    </Col>
                                </Row>

                                {/* Third Row: Takes roughly half the space, content centered */}
                                <Row className="g-3 flex-grow-1 align-items-end justify-content-center"> {/* Added flex utilities */}
                                    <Col className="text-left">
                                        <span className="hover-text-100 text-white fs-7 fw-semi-bold">
                                            {t("Home.manage")}
                                        </span>
                                    </Col>
                                </Row>
                            </Card.Body>


                        </Card>
                    </Col>
                </Row>

                <Row className='mt-4 p-4 rounded-2'>
                    <Col lg={4} xl={4} className="d-none d-lg-block">
                        <Card className="min-vh-20 cursor-pointer" style={{ background: 'radial-gradient(circle, rgba(1,149,177,1) 0%, rgba(82,143,198,1) 100%)' }}
                            onClick={() => navigate("/myskills")}>
                            <Card.Body className="d-flex flex-column justify-content-center"> {/* Added flex utilities */}
                                {/* First Row: Takes roughly half the space, content centered */}
                                <Row className="flex-grow-1 align-items-start justify-content-center" style={{ maxHeight: "60px" }}> {/* Added flex utilities */}
                                    <Col xs={8} sm={8}>
                                    </Col>
                                    <Col xs={4} sm={4} className="text-center text-sm-end"> {/* Center on small, align end on sm+ */}
                                        <img width={100}
                                            src={Skills}
                                            alt="skills" />
                                    </Col>
                                </Row>

                                {/* Second Row: Takes the "rest" of the space, content centered */}
                                <Row className="flex-grow-1 align-items-center justify-content-center"> {/* Added flex utilities */}
                                    <Col className="text-center"> {/* Centered content */}
                                        <h2 className="text-white">{t('Home.skills')}</h2>
                                    </Col>
                                </Row>

                                {/* Third Row: Takes roughly half the space, content centered */}
                                <Row className="g-3 flex-grow-1 align-items-end justify-content-center"> {/* Added flex utilities */}
                                    <Col className="text-left">
                                        <span className="hover-text-100 text-white fs-7 fw-semi-bold">
                                            Assess{/*t("Home.improve")*/}
                                        </span>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col lg={4} xl={4}>
                        <Card className="min-vh-20 cursor-pointer" style={{ background: 'linear-gradient(121deg, rgba(238,201,86,1) 0%, rgba(234,180,57,1) 100%)' }}
                            onClick={() => navigate("/feedback-dashboard")}>

                            <Card.Body className="d-flex flex-column justify-content-center"> {/* Added flex utilities */}
                                {/* First Row: Takes roughly half the space, content centered */}
                                <Row className="flex-grow-1 align-items-start justify-content-center" style={{ maxHeight: "60px" }}> {/* Added flex utilities */}
                                    <Col xs={8} sm={8}>

                                    </Col>
                                    <Col xs={4} sm={4} className="text-center text-sm-end"> {/* Center on small, align end on sm+ */}
                                        <img width={100}
                                            src={Feedback}
                                            alt="feedback"
                                        />
                                    </Col>
                                </Row>

                                {/* Second Row: Takes the "rest" of the space, content centered */}
                                <Row className="flex-grow-1 align-items-center justify-content-center"> {/* Added flex utilities */}
                                    <Col className="text-center"> {/* Centered content */}
                                        <h2 className="text-white">{t("Home.feedback")}</h2>
                                    </Col>
                                </Row>

                                {/* Third Row: Takes roughly half the space, content centered */}
                                <Row className="g-3 flex-grow-1 align-items-end justify-content-center"> {/* Added flex utilities */}
                                    <Col className="text-left">
                                        <span className="hover-text-100 text-white fs-7 fw-semi-bold">
                                            {t("Home.improve")}
                                        </span>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col lg={4} xl={4}>
                        <Card className="min-vh-20 cursor-pointer" style={{ background: 'linear-gradient(121deg, rgba(195,109,216,1) 0%, rgba(112,86,210,1) 100%)' }}
                            onClick={() => navigate("/analytics")}>
                            <Card.Body className="d-flex flex-column justify-content-center"> {/* Added flex utilities */}
                                {/* First Row: Takes roughly half the space, content centered */}
                                <Row className="flex-grow-1 align-items-start justify-content-center" style={{ maxHeight: "60px" }}> {/* Added flex utilities */}
                                    <Col xs={8} sm={8}>

                                    </Col>
                                    <Col xs={4} sm={4} className="text-center text-sm-end"> {/* Center on small, align end on sm+ */}
                                        <img width={100}
                                            src={Analytics}
                                            alt={t("Analytics.title")}
                                            className=''
                                        />
                                    </Col>
                                </Row>

                                {/* Second Row: Takes the "rest" of the space, content centered */}
                                <Row className="flex-grow-1 align-items-center justify-content-center"> {/* Added flex utilities */}
                                    <Col className="text-center"> {/* Centered content */}
                                        <h2 className="text-white">{t("Home.analytics")}</h2>
                                    </Col>
                                </Row>

                                {/* Third Row: Takes roughly half the space, content centered */}
                                <Row className="g-3 flex-grow-1 align-items-end justify-content-center"> {/* Added flex utilities */}
                                    <Col className="text-left">
                                        <span className="hover-text-100 text-white fs-7 fw-semi-bold">
                                            {t("Home.monitor")}
                                        </span>
                                    </Col>
                                </Row>
                            </Card.Body>


                        </Card>
                    </Col>
                </Row>
            </div>
            <Row className="p-4 rounded-2">
                <Col lg={7} xl={7}>

                    {/*
                    <Card className="w d-flex flex-row align-items-center p-4 border-0 shadow-sm rounded-4 mb-4" >
                        <div className="d-flex justify-content-center align-items-center rounded-circle  ms-4 me-3" style={{ width: "64px", height: "64px" }}>
                            <Image src={DashboardExpert} alt="icon" width={64} height={64} />
                        </div>
                        <Card.Text className="mb-0 small text-muted fs-6">
                            Start here. Ask the Platform Expert where to find what you need. Explain what you are looking for and start your personal journey.
                        </Card.Text>
                    </Card>
                    */}

                    <PromptWidgetv2 page="main_dashboard" />

                    <MagazinePreview />
                </Col>

                <Col lg={5} xl={5}>
                    <Card className='h-100 p-4'>

                        <WorkLifeBalanceBox type="WLB" />

                        {/* <TaskList type="reminder" /> */}
                    </Card>
                </Col>
            </Row>

            <NavbarBottom active="home" className="d-lg-none" />
        </>
    );
};


export default UserDashboard;